module.exports = __webpack_public_path__ + "static/media/header_image-Recovered-Recovered.05b02378.png";